import React, { useContext } from 'react';

const RandomBackgroundContext = React.createContext<string>('');

export default RandomBackgroundContext;

export function useRandomBackground() {
    return useContext(RandomBackgroundContext);
}